import vSearchLocal from "./v-search-local.vue";

export default Vue => {
  Vue.component("v-search-local", vSearchLocal);
};
